<style lang="css">
@import '../css/bootstrap.css';
@import '../css/bootstrap-vue.css';
@import '../css/admin-table.css';
</style>
<style lang="scss" scoped>
@import '../css/admin.scss';
</style>
<template>
  <div class="admin-page">
    <admin-header :tit="this.title"></admin-header>
    <admin-side></admin-side>
    <section class="admin-template">
      <h2 class="sub-tit">추천 매물 관리</h2>
      <div class="contents">
        <b-container fluid>
          <!-- User Interface controls -->
            <b-row>
             <b-col class="my-1 text-left type-box">
               <b-form-group
                label="매물 Type"
                label-for="form-select"
                label-cols-sm="3"
                label-align-sm="left"
                label-size="sm"
                class="mb-0 "
              >
               <b-form-select size="sm" class="item-select" id="form-select" v-model="typeSelected" :options="itemOptions"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col class="my-1 filter-box">
              <b-form-group
                label="Filter"
                label-for="filter-input"
                label-cols-sm="1"
                label-align-sm="left"
                label-size="sm"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filter-input"
                    type="search"
                    placeholder="검색어를 입력해주세요."
                  ></b-form-input>
                  <b-button size="sm" @click="itemFilter()" class="search-btn">검색</b-button>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- Main table element -->
          <b-table
            id="table-recommended-items"
            :items="items"
            :fields="fields"
            stacked="md"
            show-empty
            small
          >
            <template #cell(name)="row">
              {{ row.value }}
            </template>
            <template #cell(address)="row">
              {{ row.value }}
            </template>
            <template #cell(actions)="row">
              <!-- <input type="text" class="default-input" :value="row.index" oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '')"> -->
              <b-button size="sm" @click="modifyItem(row.item, row.index)" class="save-btn mr-1">수정</b-button>
              <b-button size="sm" @click="deleteItem(row.item, row.index)" class="deleat-btn">삭제</b-button>
            </template>
            <template #row-details="row">
              <b-card>
                <ul>
                  <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
                </ul>
              </b-card>
            </template>
          </b-table>
           <b-row>
            <b-col lg="12" class="my-1 text-right">
              <b-button variant="primary" class="new-item-btn" @click="resetModal()">신규</b-button>
            </b-col>
          </b-row>
          <b-modal
          id="total-modal"
          class="item-modal"
          size="lg"
          title="추천매물 추가하기"
          >
            <b-row class="modal-top-row">
              <b-col sm="7" class="my-1 modal-top-area">
                <div class="my-1 text-left modal-top-left">
                  <label>매물 Type</label>
                  <b-form-input
                    v-model="typeSelectNm"
                    disabled
                  ></b-form-input>
                </div>
                <div class="my-1 text-left modal-top-center">
                  <label>매물 번호</label>
                  <b-form-input
                    id="filter-input"
                    v-model="modalSearchNumber"
                    type="search"
                    placeholder="매물번호를 입력해주세요."
                  ></b-form-input>
               </div>
              </b-col>
              <b-col sm="5" class="my-1">
                <div class="my-1 modal-top-right">
                  <label>매물명</label>
                  <b-form-input
                    id="filter-input"
                    v-model="modalSearchName"
                    type="search"
                    placeholder="검색어를 입력해주세요."
                  ></b-form-input>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="my-1 text-left type-box">
                <b-form-select size="sm" class="item-select" id="form-select" v-model="modalAddressFirstSelected" :options="modalAddressFirst">
                </b-form-select>
              </b-col>
              <b-col class="my-1 text-left type-box">
                <b-form-select size="sm" class="item-select" id="form-select" v-model="modalAddressSecondSelected" :options="modalAddressSecond">
                </b-form-select>
              </b-col>
              <b-col class="my-1 text-left type-box">
                <b-form-select size="sm" class="item-select" id="form-select" v-model="modalAddressThirdSelected" :options="modalAddressThird">
                </b-form-select>
              </b-col>
              <b-col class="my-1 filter-box text-right">
                <b-button size="sm" @click="allItemFilter()" class="btn-primary search-btn">검색</b-button>
              </b-col>
            </b-row>
            <b-table
              id="table-recommended-items"
              :items="allItems"
              :fields="allFields"
              :select-mode="selectMode"
              responsive="sm"
              ref="selectableTable"
              selectable
              @row-selected="onRowSelected"
              show-empty
              small
            >
              <template #cell(selected)="{ rowSelected }">
                <template v-if="rowSelected">
                  <span aria-hidden="true">&check;</span>
                  <span class="sr-only">Selected</span>
                </template>
                <template v-else>
                  <span aria-hidden="true">&nbsp;</span>
                  <span class="sr-only">Not selected</span>
                </template>
              </template>
            </b-table>
            <template #modal-footer class="modify-footer-area">
              <b-col class="my-1 text-left type-box footer-command-box" sm="12">
                <label>추천 문구</label>
                <b-form-input class="footer-command"
                  v-model="modalInputText"
                ></b-form-input>
              </b-col>
              <b-col class="my-1 text-left type-box new-command-box" sm="12">
                <div class="left-column">
                  <label>추천 순번</label>
                    <b-form-input
                      v-model="modalInputNumber"
                      oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '')"
                    ></b-form-input>
                  <!--<b-form-select size="sm" class="item-select" id="form-select" v-model="itemOrderSelected" :options="itemOrder">
                  </b-form-select>-->
                </div>
                <div class="right-column">
                  <b-button
                  variant="primary"
                  size="sm"
                  @click="modalSave()"
                >
                  저장
                </b-button>
                </div>
              </b-col>
            </template>
          </b-modal>
          <b-modal :id="infoModal.id" size="lg" class="item-modal modify-modal" :title="infoModal.title" ok-only>
            <b-row class="modal-top-row">
              <b-col sm="7" class="my-1 modal-top-area">
                <div class="my-1 text-left modal-top-left">
                  <label>매물 Type</label>
                  <b-form-input
                    v-model="infoModal.type"
                    disabled
                  ></b-form-input>
                </div>
                <div class="my-1 text-left modal-top-center">
                  <label>매물 번호</label>
                  <b-form-input
                    v-model="infoModal.number"
                    disabled
                  ></b-form-input>
               </div>
              </b-col>
              <b-col sm="5" class="my-1">
                <div class="my-1 modal-top-right">
                  <label>매물명</label>
                  <b-form-input
                    v-model="infoModal.estateDest"
                    disabled
                  ></b-form-input>
                </div>
              </b-col>
            </b-row>
            <b-row class="modal-second-row">
              <b-col sm="12" class="my-1 modal-second-area">
                <div class="my-1 text-left">
                  <label>매물 주소</label>
                  <b-form-input
                    v-model="infoModal.address"
                    disabled
                  ></b-form-input>
                </div>
              </b-col>
            </b-row>
            <b-row class="modal-third-row">
              <b-col sm="12" class="my-1 modal-third-area">
                <div class="my-1 text-left">
                  <label>추천 문구</label>
                  <b-form-input
                    v-model="infoModal.command"
                  ></b-form-input>
                </div>
              </b-col>
            </b-row>
            <template #modal-footer>
              <b-row class="modify-footer">
                <b-col b-col sm="3" class="my-1 modify-seleted">
                  <label>추천 순번</label>
                  <b-form-input
                    v-model="infoModal.commandOrd"
                    oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '')"
                  ></b-form-input>
                  <!--<b-form-select size="sm" class="item-select" id="form-select" v-model="itemOrderSelected" :options="itemOrder">
                  </b-form-select>-->
                </b-col>
                <b-col b-col sm="6" class="my-1 modify-save-area">
                  <b-button
                  variant="primary"
                  size="sm"
                  @click="modifySave()"
                >
                  저장
                </b-button>
                </b-col>
              </b-row>
            </template>
          </b-modal>
        </b-container>
      </div>
    </section>
  </div>
</template>
<script>
import AdminHeader from '@/components/AdminHeader'
import AdminSide from '@/components/AdminSide'
import { mapGetters } from 'vuex'

export default {
  name: 'RecommendedItems',
  components: {
    'admin-header': AdminHeader,
    'admin-side': AdminSide
  },
  data () {
    return {
      title: '관리자 페이지',
      modalAddressFirstSelected: '0',
      modalAddressSecondSelected: '0',
      modalAddressThirdSelected: '0',
      modalAddressFirst: [
        { value: '0', text: '시도 선택' }
      ],
      modalAddressSecond: [
        { value: '0', text: '구군 선택' }
      ],
      modalAddressThird: [
        { value: '0', text: '동면동 선택' }
      ],
      typeSelected: '',
      typeSelectNm: '',
      modalSearchNumber: '',
      modalSearchName: '',
      modalInputText: '',
      modalInputNumber: '',
      itemOptions: [],
      allFields: [
        { key: 'selected', label: '선택', class: 'text-center' },
        { key: 'number', label: '매물번호', class: 'text-center' },
        { key: 'name', label: '매물명', sortDirection: 'desc' },
        { key: 'address', label: '주소', sortDirection: 'desc' }
      ],
      allItems: [],
      selectMode: 'range',
      selected: [],
      fields: [
        { key: 'estateId', label: '매물번호', class: 'text-center' },
        { key: 'commandTxt', label: '추천명', sortDirection: 'desc' },
        { key: 'address', label: '주소', sortDirection: 'desc' },
        { key: 'commandOrd', label: '추천순서', class: 'text-center', sortDirection: 'desc' },
        { key: 'actions', label: '', class: 'text-center' }
      ],
      totalRows: 1,
      infoModal: {
        id: 'info-modal',
        title: '',
        estateDest: '아주 좋은집이 싸게 나왔어요',
        type: '주거',
        typeNo: '001',
        number: '40',
        address: '서울시 영등포구 신길4동 삼성래미안 113동 1301221호',
        command: '까먹었네요 나중에 다시 입력하겠습니다.',
        commandOrd: '3'
      }
    }
  },
  created () {
    this.initEstateCode()
  },
  watch: {
    typeEstate () {
      for (var i = 0; i < this.typeEstate.length; i++) {
        let tmp = { value: this.typeEstate[i].deCode, text: this.typeEstate[i].codeNm }
        this.itemOptions.push(tmp)
      }
      this.typeSelected = this.typeEstate[0].deCode
      this.typeSelectNm = this.typeEstate[0].codeNm
    },
    typeSelected () {
      this.$store.dispatch('apiRecommandInfo', {'codeType': this.typeSelected})
      this.$store.dispatch('apiRecommandArea', {'codeType': this.typeSelected})
      this.getTypeText()
    },
    modalAddressFirstSelected () {
      this.modalAddressSecondSelected = ''
      this.modalAddressThirdSelected = ''
      this.modalAddressSecond = [ { value: '', text: '시구군 선택' } ]
      this.modalAddressThird = [ { value: '', text: '읍면동 선택' } ]
      let tmpArr = this.getAreaValues(2)
      // console.log('tmpArr = ' + tmpArr)
      for (let i = 0; i < tmpArr.length; i++) {
        let tmpItem = { value: tmpArr[i], text: tmpArr[i] }
        this.modalAddressSecond.push(tmpItem)
      }
    },
    modalAddressSecondSelected () {
      this.modalAddressThirdSelected = ''
      this.modalAddressThird = [ { value: '', text: '읍면동 선택' } ]
      let tmpArr = this.getAreaValues(3)
      // console.log('tmpArr = ' + tmpArr)
      for (let i = 0; i < tmpArr.length; i++) {
        let tmpItem = { value: tmpArr[i], text: tmpArr[i] }
        this.modalAddressThird.push(tmpItem)
      }
    },
    searchData () {
      this.allItems = []
      // console.log('여기여기1')
      for (let i = 0; i < this.searchData.length; i++) {
        this.allItems.push({number: this.searchData[i].estateId, name: this.searchData[i].estateDesc, address: this.searchData[i].address})
      }
      // console.log('여기여기2')
      if (this.allItems.length === 0) {
        alert('검색 된 데이터가 존재하지 않습니다.')
      }
    }
  },
  methods: {
    modifyItem (item, index) {
      this.infoModal.id = 'info-modal'
      this.infoModal.title = '추천매물 수정하기'
      this.infoModal.estateDest = item.estateDesc
      this.infoModal.type = this.getTypeText()
      this.infoModal.typeNo = this.typeSelected
      this.infoModal.number = item.estateId
      this.infoModal.address = item.address
      this.infoModal.command = item.commandTxt
      this.infoModal.commandOrd = item.commandOrd
      this.infoModal.estateId = item.estateId
      this.infoModal.commandTxt = item.commandTxt
      this.$root.$emit('bv::show::modal', this.infoModal.id)
    },
    deleteItem (item, index) {
      const deleteConfirm = confirm('정말 삭제하시겠습니까??')
      if (deleteConfirm === true) {
        // console.log(item)
        this.$store.dispatch('apiTranRecommandInfo', {'flag': 'D', 'item': item}).then(() => {
          // console.log('this.tranRtnStr = ' + this.tranRtnStr)
          if (this.tranRtnStr === 'success') {
            this.$store.dispatch('apiRecommandInfo', {'codeType': this.typeSelected})
            this.$store.dispatch('apiRecommandArea', {'codeType': this.typeSelected})
          } else {
            alert('삭제에 실패하였습니다.')
          }
        })
        // this.items.splice(index, 1)
      } else {
        return false
      }
    },
    itemFilter () {
      alert('itemFilter')
    },
    allItemFilter () {
      this.selected = []
      this.$store.dispatch('apiRecommandSearch', {'codeType': this.typeSelected, 'searchId': this.modalSearchNumber, 'searchName': this.modalSearchName, 'searchArea1': this.modalAddressFirstSelected, 'searchArea2': this.modalAddressSecondSelected, 'searchArea3': this.modalAddressThirdSelected})
    },
    modifySave () {
      this.$store.dispatch('apiTranRecommandInfo', {'flag': 'U', 'item': this.infoModal}).then(() => {
        // console.log('this.tranRtnStr = ' + this.tranRtnStr)
        if (this.tranRtnStr === 'success') {
          this.$nextTick(() => {
            this.$bvModal.hide('info-modal')
          })
          this.$store.dispatch('apiRecommandInfo', {'codeType': this.typeSelected})
          this.$store.dispatch('apiRecommandArea', {'codeType': this.typeSelected})
        } else {
          alert('수정 된 내용 저장에 실패하였습니다.')
        }
      })
    },
    modalSave () {
      if (this.modalInputText === '') {
        alert('추천 문구를 입력하세요.')
        return
      }
      if (this.modalInputNumber === '') {
        alert('추천 순번을 입력하세요.')
        return
      }
      if (this.selected.length === 0) {
        alert('선택 된 매물이 없습니다. 매물을 선택해주세요.')
        return
      }
      let tmpItem = {estateId: this.selected[0].number, commandTxt: this.modalInputText, commandOrd: this.modalInputNumber}
      this.$store.dispatch('apiTranRecommandInfo', {'flag': 'I', 'item': tmpItem}).then(() => {
        // console.log('this.tranRtnStr = ' + this.tranRtnStr)
        if (this.tranRtnStr === 'success') {
          this.$nextTick(() => {
            this.$bvModal.hide('total-modal')
          })
          this.$store.dispatch('apiRecommandInfo', {'codeType': this.typeSelected})
          this.$store.dispatch('apiRecommandArea', {'codeType': this.typeSelected})
        } else {
          alert('수정 된 내용 저장에 실패하였습니다.')
        }
      })
    },
    onRowSelected (items) {
      this.selected = items
    },
    resetModal () {
      if (this.area.length === 0) {
        alert(this.typeSelectNm + ' 타입의 추천할 매물이 존재하지 않습니다.')
        return
      } else {
        this.$root.$emit('bv::show::modal', 'total-modal')
      }
      this.selected = []
      this.modalSearchNumber = ''
      this.modalSearchName = ''
      this.modalInputText = ''
      this.modalInputNumber = ''
      this.allItems = []
      this.initAreaBox()
    },
    initEstateCode () {
      this.$store.dispatch('apiEtcCodelists', {'Code': '001', 'DeCode': ''})
    },
    initAreaBox () {
      this.modalAddressFirstSelected = ''
      this.modalAddressSecondSelected = ''
      this.modalAddressThirdSelected = ''
      this.modalAddressFirst = [ { value: '', text: '시도 선택' } ]
      this.modalAddressSecond = [ { value: '', text: '구군 선택' } ]
      this.modalAddressThird = [ { value: '', text: '동면동 선택' } ]
      let tmpArr = this.getAreaValues(1)
      for (let i = 0; i < tmpArr.length; i++) {
        let tmpItem = { value: tmpArr[i], text: tmpArr[i] }
        this.modalAddressFirst.push(tmpItem)
      }
    },
    getAreaValues (val) {
      let tmpArray = []
      if (val === 1) {
        for (let i = 0; i < this.area.length; i++) {
          if (tmpArray.indexOf(this.area[i].sido) === -1) {
            tmpArray.push(this.area[i].sido)
          }
        }
      } else if (val === 2) {
        for (let i = 0; i < this.area.length; i++) {
          if (tmpArray.indexOf(this.area[i].gugun) === -1 && this.modalAddressFirstSelected === this.area[i].sido) {
            tmpArray.push(this.area[i].gugun)
          }
        }
      } else {
        for (let i = 0; i < this.area.length; i++) {
          if (tmpArray.indexOf(this.area[i].dong) === -1 && this.modalAddressFirstSelected === this.area[i].sido && this.modalAddressSecondSelected === this.area[i].gugun) {
            tmpArray.push(this.area[i].dong)
          }
        }
      }
      return tmpArray
    },
    getTypeText () {
      let typeStr = ''
      for (let i = 0; i < this.typeEstate.length; i++) {
        if (this.typeSelected === this.itemOptions[i].value) {
          typeStr = this.itemOptions[i].text
          this.typeSelectNm = typeStr
          break
        }
      }
      return typeStr
    }
  },
  computed: {
    ...mapGetters({
      typeEstate: 'getEtcCode001List',
      items: 'getRecommandItem',
      area: 'getRecommandArea',
      tranRtnStr: 'getRecommandTran',
      searchData: 'getRecommandSearch'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/admin/RecommendedItems.vue